import React, { useEffect, useState, useRef, useCallback } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';

import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import ClipLoader from "react-spinners/ClipLoader";

import api from '../../services/api'
import format from '../../services/Format'

import moment from 'moment-timezone';
import 'moment/locale/pt-br';
moment.locale('pt-br');

const styles = {
  iconInput: {
    fontSize: 18,
    color: '#bbbbbb',
    marginTop: -2,
    marginLeft: 16
  },

  iconInputMini: {
    fontSize: 20,
    color: '#bbbbbb',
    marginTop: 0,
    marginLeft: 10
  },

  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },

  cardTitleWhite: {
    height: '30px',
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '22px',
    lineHeight: '30px',
    textAlign: 'center'
  },

  container: {
    justifyContent: 'center',
    alignItems: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },

  company: {
    height: '38px',
    color: '#BDBDBD',
    fontFamily: "Open Sans",
    fontSize: '14px',
    lineHeight: '19px',
    textAlign: 'center'
  },

  hora: {
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '30px',
    lineHeight: '20px',
    textAlign: 'center',
    fontWeight: '600',
    marginTop: '67px'
  },

  dayInfo: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'center'
  },

  button: {
    borderRadius: '100px !important',
    backgroundLinearGradient: '180deg, #F5F6FB 0%, #E4E7EE 100%',
    backgroundColor: '#f8f9fd',
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '19px',
    textAlign: 'center',
    border: '7px solid',
    borderColor: '#e6eaf1 !important',
    textTransform: 'none'
  },

  register: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '700',
    height: '10px'
  },

  registerOk: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '700',
    height: '5px'
  },

  map: {
    padding: ' 0px 0px !important'
  },

  footer: {
    justifyContent: 'center',
    alignItems: 'baseline',
    display: 'grid',
    padding: '0px !important',
  },

  divRegister: {
    height: '29px'
  },

  gridItem: {
    alignItems: 'center'
  },

  grid: {
    height: '100%'
  },

  icon: {
    color: '#BDBDBD',
    fontSize: '18px'
  },

  input: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '16px',
    width: '100% !important',
    height: '40px !important',
  },

  form: {
    width: '46% !important',
    margin: 7,
  },

  formCalendar: {
    width: '50% !important',
    margin: 7
  },

  text: {
    textAlign: 'center',
    color: '#1989ff',
    fontFamily: "Open Sans",
    fontSize: '26px',
    fontWeight: '400',
    lineHeight: '42px'
  },

  textInfo: {
    color: '#828282',
    height: '0px',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 15
  },

  textInfoMarcacoes: {
    color: '#828282',
    height: '0px',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 30
  },

  inputLabel: {
    top: '3px',
    position: 'relative',
    marginRight: '15px',
    color: '#828282',
    fontSize: '14px',
    fontWeight: '600',
    width: 60,
    textAlign: 'left'
  },
};

const useStyles = makeStyles(styles);

export default function Justificativa() {
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const formRef = useRef();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToasts();
  const [data, setData] = useState('');
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);
  const [campoMarcacoes, setCampoMarcacoes] = useState([1]);
  const [anexos, setAnexos] = useState([]);
  const [fileNames, setFileNames] = useState(null);
  const [sucesso, setSucesso] = useState(false);
  const [marcacoes, setMarcacoes] = useState('');

  useEffect(() => {
    (async () => {
      try {
        let usuario = await api.getUsuario();        
        if (usuario.success) {
          if ((usuario.data.sisRegPonto == 1) || (usuario.data.sisRegPonto == 4)) {
            history.push("/restrito")            
          }
          else {
            if (location.state?.data) {
              setData(location.state.data.split("/").reverse().join("-"));
            }
            if (location.state?.marcacoes) {
              setMarcacoes(location.state.marcacoes);
            }
          }
        } else {
          setLoading(false);
          if (usuario.statusCode === 401) {
            localStorage.clear();
            history.push("/");
            addToast(usuario.message, { appearance: 'error' });
          } else {
            addToast(usuario.message, { appearance: 'error' });
          }
        }
      } catch (err) {
        setLoading(false);
        if (err.statusCode === 401) {
          localStorage.clear();
          history.push("/");
          addToast(err.message, { appearance: 'error' });
        } else {
          addToast(err.message, { appearance: 'error' });
        }
      }
    })();
  }, []);

  const removerArquivo = (index) => {
    var newFileList = Array.from(anexos);
    newFileList.splice(index,1);
    setAnexos(newFileList);
    const files = Array.from(newFileList).map(file => {
      return { name: file.name, size: Math.round(file.size / 1024) }
    });
    setFileNames(files);
  }

  const justificar = async () => {
    if (!data) {
      addToast("Por favor, informe a data da justificativa!", { appearance: 'error' });
      return;
    }
    else if (!motivo) {
      addToast("Por favor, informe o motivo da justificativa!", { appearance: 'error' });
      return;
    }

    let anexo = null;
    let arrMarcacoes = [];
    const form = formRef.current;
    campoMarcacoes.map(i => {
      arrMarcacoes.push(form[`entrada${i}`].value);
      arrMarcacoes.push(form[`saida${i}`].value);
    })

    let existeMarcacoes = arrMarcacoes?.find(el => el !== '');
    if (!existeMarcacoes && Array.from(anexos).length === 0) {
      addToast("Por favor, informe ao menos um horário para ajuste do cartão ponto!", { appearance: 'error' });
      return;
    }

    try {
      setLoading(true);
      if (Array.from(anexos).length > 0) {
        let formData = new FormData();
        Array.from(anexos).map(file => {
          formData.append("files", file);
        });
        let upload = await api.upload(formData);
        if (upload.success) {
          anexo = upload.file;
        } else {
          addToast(upload.message, { appearance: 'error' });
          return;
        }
      }

      let batida = await api.cadastrarJustificativa({ data, motivo, anexo, marcacoes: arrMarcacoes });
      if (batida.success) {
        anexo = null;
        setAnexos([]);
        setFileNames(null);
        setData("");
        setMotivo("");
        setLoading(false);
        setSucesso(true);
      } else {
        setLoading(false);
        addToast(batida.message, { appearance: 'error' });
      }
    } catch (err) {
      setLoading(false);
      if (err.statusCode === 401) {
        localStorage.clear();
        history.push("/");
      }
      addToast(err.message, { appearance: 'error' });
    }
  }

  const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files).map(file => {
      return { name: file.name, size: Math.round(file.size / 1024) }
    });
    setFileNames(files);
    setAnexos(e.target.files);
  }

  const addDelMarcacoes = (tipo) => {
    if (tipo === '+') {
      let pos = campoMarcacoes.length + 1;
      campoMarcacoes.push(pos);
      console.log(campoMarcacoes);
    } else {
      if (campoMarcacoes.length > 1) {
        let pos = campoMarcacoes.length - 1;
        campoMarcacoes.splice(pos, 1);
        console.log(campoMarcacoes);
      }
    }
    forceUpdate();
  }

  const getIconAnexo = (file) => {
    let fileName = file.split(".");
    let ext = fileName[fileName.length-1];
    if (ext === 'csv') return 'icon-file-csv';
    if (ext === 'html') return 'icon-file-html';
    if (ext === 'rar') return 'icon-file-rar';
    if (ext === 'xml') return 'icon-file-xml';
    if (ext === 'zip') return 'icon-file-zip1';
    if (ext === 'bmp') return 'icon-image-file-bmp';
    if (ext === 'gif') return 'icon-image-file-gif';
    if (ext === 'jpg') return 'icon-image-file-jpg';
    if (ext === 'jpeg') return 'icon-image-file-jpg';
    if (ext === 'png') return 'icon-image-file-png';
    if (ext === 'doc') return 'icon-office-file-doc-1';
    if (ext === 'docx') return 'icon-office-file-doc-1';
    if (ext === 'pdf') return 'icon-office-file-pdf-1';
    if (ext === 'pps') return 'icon-office-file-pps-1';
    if (ext === 'ppt') return 'icon-office-file-ppt-1';
    if (ext === 'rtf') return 'icon-office-file-rtf-1';
    if (ext === 'txt') return 'icon-office-file-txt-1';
    if (ext === 'xls') return 'icon-office-file-xls-1';
    else return 'icon-file-empty';
  }

  if (sucesso) {
    return (
      <div className={classes.gridContainer} style={{ padding: 0 }}>
        <GridContainer style={{ position: 'fixed', justifyContent: 'center', height: '100%', alignItems: 'center', padding: 0, zIndex: 1 }} >
          <GridItem style={{ padding: 0 }}>
            <Card style={{
              backgroundColor: '#f8f9fd',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
              borderTopLeftRadius: 25,
              borderTopRightRadius: 25,
              borderColor: '#C8C8C8',
              borderRadius: '25px',
              minHeight: '530px',
              width: '400px',
              textAlign: 'center',
              boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)',
              padding: 0,
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <CardHeader style={{ padding: '8px 5px 0px 5px', justifyContent: 'center', borderBlockEnd: '1px solid #EEEFF4', textAlign: 'center' }}>
                <label className={classes.text}>Justificar Ausência</label>
              </CardHeader>

              <CardBody style={{ top: 20, width: '100%', height: '100%', textAlign: 'center', textAlign: '-webkit-center' }}>
                <div style={{ borderRadius: 50, border: '8px solid #d8dee9', padding: 19, width: 100, height: 100 }}>
                  <i className="icon-check-double" style={{ fontSize: 46, color: '#1a88ff' }} />
                </div>
                <p style={{ color: '#1989ff', fontSize: '14px', fontWeight: '700', marginTop: 20, lineHeight: 0 }}>Justificativa Enviada</p>
                <p style={{ color: '#828282', fontSize: '12px', marginTop: 20, lineHeight: 0 }}>{moment().format("DD/MM/YYYY - HH:mm")}</p>
                <p style={{ color: '#828282', fontSize: '18px', fontWeight: 'bold', marginTop: 30, lineHeight: 1.2 }}>{`Agradecemos o envio\nda sua justificativa!`}</p>
                <p style={{ color: '#828282', fontSize: '16px', marginTop: 30, lineHeight: 1.2 }}>{`Nosso departamento de Recursos Humanos analisará sua justificativa e em breve você poderá visualizar a atualização no painel de histórico de registros.`}</p>
              </CardBody>

              <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', marginBottom: 20 }}>
                <Button style={{ borderRadius: '25px', width: 140 }} onClick={() => setSucesso(false)} color="primary" disabled={loading}>Voltar</Button>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  } else {
    return (
      <div className={classes.gridContainer} style={{ padding: 0 }}>
        <GridContainer style={{ position: 'fixed', justifyContent: 'center', height: '100%', alignItems: 'center', padding: 0, zIndex: 1 }} >
          <GridItem style={{ padding: 0 }}>
            <Card style={{
              backgroundColor: '#f8f9fd',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
              borderTopLeftRadius: 25,
              borderTopRightRadius: 25,
              borderColor: '#C8C8C8',
              borderRadius: '25px',
              minHeight: '530px',
              width: '400px',
              textAlign: 'center',
              boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)',
              padding: 0
            }}>
              <CardHeader style={{ padding: '8px 5px 0px 5px', justifyContent: 'center', borderBlockEnd: '1px solid #EEEFF4', textAlign: 'center' }}>
                <label className={classes.text}>Justificar Ausência</label>
              </CardHeader>

              <CardBody style={{ padding: 0 }}>
                <form ref={formRef}>
                  <GridItem style={{ borderBlockEnd: '1px solid #EEEFF4' }}>
                    <h2 className={classes.textInfo}>Informe a data da justificativa</h2>

                    <FormControl xs={12} sm={12} md={12} style={{ marginTop: 25, marginBottom: 15 }}>
                      <Input xs={12} sm={12} md={12}
                        autoFocus={false}
                        disableUnderline
                        style={{ height: 35 }}
                        inputProps={{
                          value: data,
                          onChange: (event) => { setData(event.target.value) },
                          type: "date"
                        }}
                        startAdornment={
                          <InputAdornment position="start">
                            <i className="icon-calendar" style={styles.iconInput} />
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </GridItem>

                  {data && marcacoes &&
                    <GridItem style={{ borderBlockEnd: '1px solid #EEEFF4' }}>
                      <h2 className={classes.textInfo}>Marcações efetuadas</h2>
                      <h2 className={classes.textInfoMarcacoes}>{marcacoes}</h2>
                    </GridItem>}

                  <GridItem>
                    <h2 className={classes.textInfo} style={{ marginBottom: 25 }}>Informe os horários para ajuste do cartão ponto</h2>
                    <div style={{ height: 90, overflowX: 'auto' }}>
                      {campoMarcacoes.map(i => {
                        return (
                          <div>
                            <GridItem style={{ display: 'inline-flex', marginTop: 10 }}>
                              <h2 className={classes.inputLabel}>Entrada</h2>
                              <FormControl xs={12} sm={12} md={12}>
                                <Input xs={12} sm={12} md={12}
                                  style={{ height: 26, width: 100 }}
                                  autoFocus={false}
                                  disableUnderline
                                  inputProps={{
                                    name: `entrada${i}`,
                                    placeholder: "__:__",
                                    onChange: (event) => {
                                      let formatValue = format.time(event.target.value);
                                      event.target.value = formatValue;
                                    },
                                  }}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      <i className="icon-time-clock-circle" style={styles.iconInputMini} />
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </GridItem>

                            <GridItem style={{ display: 'inline-flex', marginTop: 10 }}>
                              <h2 className={classes.inputLabel}>Saída</h2>
                              <FormControl xs={12} sm={12} md={12}>
                                <Input xs={12} sm={12} md={12}
                                  style={{ height: 26, width: 100 }}
                                  autoFocus={false}
                                  disableUnderline
                                  inputProps={{
                                    name: `saida${i}`,
                                    placeholder: "__:__",
                                    onChange: (event) => {
                                      let formatValue = format.time(event.target.value);
                                      event.target.value = formatValue;
                                    },
                                  }}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      <i className="icon-time-clock-circle" style={styles.iconInputMini} />
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </GridItem>
                          </div>
                        )
                      })}
                    </div>
                  </GridItem>

                  <GridItem style={{ marginBottom: 15, marginTop: 5 }}>
                    <i className="icon-plus"
                      style={{ backgroundColor: '#1989ff', color: '#fff', borderRadius: 50, padding: '4px 15px 4px 15px', marginRight: 5, cursor: 'pointer' }}
                      onClick={async () => {
                        addDelMarcacoes('+');
                      }} 
                    />

                    <i className="icon-minus"
                      style={{ backgroundColor: '#1989ff', color: '#fff', borderRadius: 50, padding: '4px 15px 4px 15px', cursor: 'pointer' }}
                      onClick={async () => {
                        addDelMarcacoes('-');
                      }}
                    />
                  </GridItem>

                  <GridItem style={{ marginBottom: 10, marginTop: 10 }}>
                    {!fileNames?.length > 0 &&
                      <div className="upload" style={{ display: 'flex', height: 37, overflow: 'hidden', padding: 10 }}>
                        <i className="icon-folder-file-1" style={{ marginBottom: 15, marginTop: 7 }} />
                        <label for="file-input" className="file-input" style={{ marginBottom: 0, border: 0, lineHeight: 0 }}>Clique aqui para selecionar anexos...</label>
                        <input id="file-input" type="file" multiple onChange={handleFileInputChange} />
                      </div>}

                    {fileNames?.length > 0 &&
                      <div className="upload" style={{ display: 'inline-grid', maxHeight: 85, overflowY: 'auto', overflowX: 'hidden', cursor: 'default', padding: 4 }}>
                        <table className="table-anexos">
                          <tbody>
                            {fileNames?.map((file, i) => {
                              return (<tr style={{ borderBottom: '1px solid #d1d1d1', borderTop: '1px solid #d1d1d1' }}>
                                <td style={{ textAlign: 'center', height: 40, width: 30 }}>
                                  <i className={getIconAnexo(file.name)} style={{ fontSize: 16, color: '#1989ff', cursor: 'default', position: 'relative', top: 2 }} />
                                </td>
                                <td style={{ textAlign: 'initial', height: 40 }}>
                                  <label for="file-input" className="file-input" style={{ marginBottom: 0, border: 0, cursor: 'default' }}>{format.subStr(30, file.name)}</label>
                                </td>
                                <td style={{ textAlign: 'center', height: 40, width: 60 }}>
                                  <label for="file-input" className="file-input" style={{ fontSize: 12, marginBottom: 0, border: 0, cursor: 'default' }}>{file.size} KB</label>
                                </td>
                                <td style={{ textAlign: 'center', height: 40, width: 30 }}>
                                  <i className="icon-cross" style={{ cursor: 'pointer', color: '#1989ff', position: 'relative', top: 2 }} onClick={() => removerArquivo(i)} />
                                </td>
                              </tr>)
                            })}
                          </tbody>
                        </table>
                      </div>}
                  </GridItem>

                  <GridItem style={{ paddingTop: 10, paddingBottom: 10 }}>
                    <textarea 
                      style={{ border: '1px solid #ddd', borderRadius: 5, width: '100%', paddingTop: 4, paddingBottom: 4, paddingLeft: 8, paddingRight: 8 }}
                      maxLength={99}
                      placeholder="Descreva o motivo"
                      onChange={(event) => setMotivo(event.target.value)}
                      value={motivo}
                      rows={2}
                      cols={5}
                    />
                    <h2 style={{ textAlign: 'left', fontSize: 12, color: '#828282', marginBottom: 0 }}>{99 - motivo.length} caracteres restantes</h2>
                  </GridItem>
                </form>
              </CardBody>

              <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', marginBottom: 20 }}>
                <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => justificar()} color="primary" disabled={loading}>Enviar</Button>
              </CardFooter>

              <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <ClipLoader
                  size={80}
                  color={"#364e6b"}
                  loading={loading}
                  css={{ border: '8px solid', borderBottomColor: 'transparent' }}
                />
              </div>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}